import { render, staticRenderFns } from "./BusinessEvaluation.vue?vue&type=template&id=6a1b9455&scoped=true"
import script from "./BusinessEvaluation.vue?vue&type=script&lang=js"
export * from "./BusinessEvaluation.vue?vue&type=script&lang=js"
import style0 from "./BusinessEvaluation.vue?vue&type=style&index=0&id=6a1b9455&prod&scoped=true&lang=css"
import style1 from "./BusinessEvaluation.vue?vue&type=style&index=1&id=6a1b9455&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1b9455",
  null
  
)

export default component.exports